import { commaNumber } from "lib/utils/numberFunctions";

function renderStatType(campaign, statType) {
  let statText;
  let statNumber;

  if (campaign) {
    switch (statType) {
      case "total_donations":
        statText = "total gifts";
        statNumber = commaNumber(campaign.total_donations);
        break;

      case "total_entity_donations":
        statText = "total gifts";
        statNumber = commaNumber(campaign.total_entity_donations);
        break;

      case "total_family_donations_count":
        statText = "total gifts";
        statNumber = commaNumber(campaign.total_family_donations_count);
        break;

      case "total_family_supporters":
        statText = "donors";
        statNumber = commaNumber(campaign.total_family_supporters || 0);
        break;

      case "total_raised":
        statText = "total dollars";
        statNumber = commaNumber(campaign.total_raised);
        break;

      case "total_unique_alumni_donors_count":
        statText = "donors";
        statNumber = commaNumber(campaign.total_unique_alumni_donors_count || 0);
        break;

      case "total_unique_family_donors_count":
        statText = "donors";
        statNumber = commaNumber(campaign.total_unique_family_donors_count);
        break;

      default:
        statText = "total gifts";
        statNumber = commaNumber(campaign.total_family_donations_count);
    }
  }
  return {
    statText,
    statNumber,
  };
}

export default renderStatType;
